import React, { useEffect, useState } from "react";
import { mapEdgesToNodes } from "../../../lib/helpers";
import { graphql, useStaticQuery } from "gatsby";
import { CardContext } from "../../card/context";
import { isFuture } from "date-fns";
import PortableText from "../../portableText";
import { EmailSignup } from "../../global/email-signup";
import { Card } from "../../card/card";

export const EventsTeaser = ({ section }) => {
  const [listing, setListing] = useState([]);

  const { events } =
    useStaticQuery(graphql`
      query EventsTeaserQuery {
        events: allSanityInvite(
          sort: { fields: [startDate], order: ASC }
        ) {
          edges {
            node {
              ...cardNodeInvite
            }
          }
        }
      }
    `) || {};

  const KOALA_CATEGORY = "6ee87d4d-fa91-43a5-af4e-a0da73caa69e";

  useEffect(() => {
    const eventNodes = events && mapEdgesToNodes(events);
    setListing(
      (eventNodes || []).filter(
        (e) =>
          isFuture(new Date(e.startDate)) &&
          !e.categories?.find((cat) => cat._id === KOALA_CATEGORY)
      )
    );
  }, [events]);

  return (
    <div className="grid md:grid-cols-2 gap-12">
      <div>
        <PortableText blocks={section._rawSummary} />
        <div className="mt-4 border border-dark-20 p-0.25 rounded-xl max-w-sm">
          <EmailSignup
            buttonText="Email me"
            placeholder="Email me event reminders"
          />
        </div>
      </div>
      <div>
        {listing.length > 0 ? (
          <ul className="grid gap-4 grid-cols-1">
            {listing.slice(0, 1).map((node, i) => (
              <li
                key={node.id}
                className={i ? "border-t-2 pt-8 mt-4 border-gray-200" : ""}
              >
                <CardContext.Provider value={{ ...node, hideType: true, url: "/events/" }}>
                  <Card />
                </CardContext.Provider>
              </li>
            ))}
          </ul>
        ) : (
          <p className="md:ml-3 text-xl text-dark-50">Loading...</p>
        )}
      </div>
    </div>
  );
};
